import home_general from './home_general'
import home_3d_scene from './home3d_scene'

export default class home3d {
  constructor(){
    window.home = this;

    console.log('home3d inited');

    this.scene = null;

    this.bound = false;
    window.homegeneral = new home_general();

    if(!window.home3dconstructed){
      this.scene = new home_3d_scene();

      if(!MOBILE) {
        window.homegeneral.checkSplash();
        window.homegeneral.checkLogo();
      } else {
        $('.splashtext').remove();
        this.doAnimation();
      }
      this.binds();
    } else {
      home.scene.pointer.x = -999;
      home.scene.pointer.y = -999;
      $('a.model').removeClass('in');
    }
  } // end constructor

  binds() {
    if(!this.bound) {
      console.log('home3d binds');
      this.bound = true;

      window.tapped = null;

      if(MOBILE) {
        // MOBILE taps n things
        $('.three-canvas').on('touchend', function(e){
          var intersect = home.scene.INTERSECTED;
          // console.log(intersect);
          if(intersect && intersect.pivot.launchDone && intersect.blockID) {

            if (!home.scene.PREV_INTERSECTED || home.scene.INTERSECTED != window.tapped){
              // if it's a new window.tapped object
              $('.model.projectlink').removeClass('in');
              if(home.scene.PREV_INTERSECTED != home.scene.INTERSECTED){
                $(home.scene.PREV_INTERSECTED.pivot).stop().animate({acceleration: 1}, 700);
              }
              window.tapped = home.scene.INTERSECTED;
              $(window.tapped.pivot).stop().animate({acceleration: 0}, 700);
              $('[data-id="'+window.tapped.blockID+'"]').addClass('in');
            } else if(home.scene.INTERSECTED == window.tapped) {
              // same as before, navigate
              var href = $('[data-id="'+window.tapped.blockID+'"]').attr('href');
              if(href && href!=='#') {
                $('.model.projectlink').removeClass('in');
                $('.notis .noti:not(.keksi)').removeClass('in');
                window.ajaxload(href, null, true, true);
              }
            }
          } else {
            if(window.tapped){
              $(window.tapped.pivot).stop().animate({acceleration: 1}, 700);
            }
            window.tapped = null;
            $('.model.projectlink').removeClass('in');
          }
        });
      } else {
        // DESKTOP
        $('.three-canvas').unbind('mousedown mouseup').mousedown(function(e){
          var intersect = home.scene.INTERSECTED;
          if(intersect && intersect.pivot.launchDone && intersect.blockID) {
            if($('[data-id="'+intersect.blockID+'"]').length>0) {
              window.mousedownBlockID = intersect.blockID;
              window.mouseDownPos = {x: e.clientX, y: e.clientY };
              // console.log(window.mouseDownPos);
            }
          }
        }).mouseup(function(e){
          e.preventDefault();
          var intersect = home.scene.INTERSECTED;
          if(intersect && intersect.pivot.launchDone && intersect.blockID) {
            if(window.mousedownBlockID == intersect.blockID){
              // console.log('still on the same thing');
              if($('[data-id="'+intersect.blockID+'"]').length>0) {
                var href = $('[data-id="'+intersect.blockID+'"]').attr('href');
                if(href && href!=='#') {
                  $('a.model').removeClass('in');
                  $('.notis .noti:not(.keksi)').removeClass('in');
                  window.ajaxload(href, null, true, true);
                }
              }
            }
          }

          window.mouseDownPos = null;
          window.mousedownBlockID = null;
        });
      }

      /*
      // WILL USE ?
      $('a.projectlink').unbind('click').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        console.log('click');
        e.stopPropagation();
        window.previousNavFrom = 'home';

        var tarText = $(this).parents('.home--cols--col').children('.home--cols--col--text').get(0);
        $(tarText).html($(this).html());

        // $(tarText).css('mix-blend-mode','normal');
        console.log(tarText);
        window.ajaxload(href, tarText);
        $(tarText).fadeOut(200);

        clearTimeout(window.notisInTimeout);
        if(window.notisInTimeoutNews){
          for(var n=0;n<window.notisInTimeoutNews.length;n++){
            clearTimeout(window.notisInTimeoutNews[n]);
            window.notisInTimeoutNews[n] = null;
          }
        }
        $('.noti:not(.keksi)').removeClass('in');
      });

      // if(!MOBILE) {
      $('.home--biglink').unbind('click mouseenter mouseleave').click(function(e){
        e.preventDefault();
        window.projectlinkclick = true;
        $(this).parents('.home--col--block').find('.projectlink').click();
      }).mouseenter(function(){
        var t = $(this).parents('.home--col--block').find('.projectlink').html();
        $(this).parents('.home--cols--col')
        .children('.home--cols--col--text')
        .html(t);
      }).mouseleave(function(){
        if(!window.projectlinkclick){
          $(this).parents('.home--cols--col').children('.home--cols--col--text').empty();
        }
      });
      if(this.domob) {
        $('.home--biglink').unbind('mouseleave')
      }
      */
    }
  }

  doAnimation() {
    console.log('doing animation');
    var home = this;
    window.home3dconstructed = true;

    this.scene.start();

    $('.header').css('opacity',1);
    $('.menu-button').addClass('in');
    $('.menu-button').addClass('noanim');

    setTimeout(function(){
      window.homegeneral.runNotis();

      $('.header').removeClass('huge');

      window.notitimeout = setTimeout(function(){
        $('.noti.news').removeClass('in');
      }, 8000);

      $('.noti').mouseenter(function(){
        clearTimeout(window.notitimeout);
      });
    }, 2000);

    setTimeout(function(){
      window.runKeksi();
    }, 3000);

  }
}
